import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTES, TABS } from '../../../../../common/constants';

const AllTabs = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const [activeTabKey, setActiveTabKey] = useState(TABS?.DELIVERY?.key);

  const tabList = [
    {
      key: TABS?.DELIVERY?.key,
      label: TABS?.DELIVERY?.label,
      children,
    },
    {
      key: TABS?.RETURN?.key,
      label: TABS?.RETURN?.label,
      children,
    },
  ];

  useEffect(() => {
    if (location?.pathname?.includes(ROUTES?.DELIVERY)) {
      setActiveTabKey(TABS?.DELIVERY?.key);
    }
    if (location?.pathname?.includes(ROUTES?.RETURN)) {
      setActiveTabKey(TABS?.RETURN?.key);
    }
  }, [location]);

  const onTabChange = (key) => {
    setActiveTabKey(key);
    switch (key) {
      case TABS?.DELIVERY?.key:
        history?.push(`${ROUTES?.ORDERS}${ROUTES?.ALL}${ROUTES?.DELIVERY}`);
        break;
      case TABS?.RETURN?.key:
        history?.push(`${ROUTES?.ORDERS}${ROUTES?.ALL}${ROUTES?.RETURN}`);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="card-container mobile-card-main">
        <Tabs
          activeKey={activeTabKey}
          type="card"
          className="full-width"
          onChange={(key) => onTabChange(key)}
          items={tabList}
          destroyInactiveTabPane
        />
      </div>
    </>
  );
};

export default AllTabs;
